import { MultilineText } from "./MultilineText";

export default MultilineText;
